module.exports = __webpack_public_path__ + "media/2.34a0ca64.mp3";